module.exports = __webpack_public_path__ + "media/images/lb/830-65dde6f667d93eda0872852d51cdb69b.svg";